import React from 'react';

const FiltrosProductos = ({
  opcionesFiltros,
  filtroCategoria,
  setFiltroCategoria,
  filtroSubcategoria,
  setFiltroSubcategoria,
  filtroMarca,
  setFiltroMarca,
  buscadorProductos,
  setBuscadorProductos,
  limpiarFiltros,
  guardarCambios,
  guardando,
  tipoVista = 'sku', // 'sku' o 'competencias'
  onAbrirEdicionMultiple
}) => {
  const getBuscadorLabel = () => {
    return tipoVista === 'competencias' ? 'Buscar competencias' : 'Buscar productos';
  };

  const getBuscadorPlaceholder = () => {
    return tipoVista === 'competencias' ? 'Buscar competencias...' : 'Buscar productos...';
  };

  const hasActiveFilters = filtroCategoria || filtroSubcategoria || filtroMarca || buscadorProductos;

  return (
    <div className="filtros-container mb-4">
      <div className="row align-items-center mb-3">
        <div className="col">
          <h6 className="filtros-titulo mb-0">
            <i className="fas fa-filter me-2"></i>
            Filtros y Búsqueda
          </h6>
        </div>
        <div className="col-auto">
          <div className="d-flex gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={limpiarFiltros}
              disabled={!hasActiveFilters}
            >
              <i className="fas fa-times me-1"></i>
              Limpiar filtros
            </button>
            
            {/* Botón de edición múltiple solo para la vista SKU */}
            {tipoVista === 'sku' && onAbrirEdicionMultiple && (
              <button
                type="button"
                className="btn btn-warning btn-sm"
                onClick={onAbrirEdicionMultiple}
                title="Editar múltiples precios"
              >
                <i className="fas fa-edit me-1"></i>
                <span className="d-none d-sm-inline">Editar Precios Múltiple</span>
              </button>
            )}
            
            {/* Botón de guardar solo para la vista SKU */}
            {tipoVista === 'sku' && (
              <button
                type="button"
                className="btn btn-success btn-sm"
                onClick={guardarCambios}
                disabled={guardando}
                title="Guardar configuración"
              >
                {guardando ? (
                  <>
                    <div className="spinner-border spinner-border-sm me-1" role="status">
                      <span className="visually-hidden">Guardando...</span>
                    </div>
                    <span className="d-none d-sm-inline">Guardando...</span>
                  </>
                ) : (
                  <>
                    <i className="fas fa-save me-1"></i>
                    <span className="d-none d-sm-inline">Guardar</span>
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
      
      {/* Primera línea: Buscador y Marca */}
      <div className="row g-3 mb-3">
        <div className="col-lg-8 col-md-6">
          <label htmlFor={`buscador-productos-${tipoVista}`} className="form-label">
            <i className="fas fa-search me-1"></i>
            {getBuscadorLabel()}
          </label>
          <input
            type="text"
            id={`buscador-productos-${tipoVista}`}
            className="form-control"
            placeholder={getBuscadorPlaceholder()}
            value={buscadorProductos}
            onChange={(e) => setBuscadorProductos(e.target.value)}
          />
        </div>

        <div className="col-lg-4 col-md-6">
          <label htmlFor={`filtro-marca-${tipoVista}`} className="form-label">
            <i className="fas fa-trademark me-1"></i>
            Marca
          </label>
          <select
            id={`filtro-marca-${tipoVista}`}
            className="form-select"
            value={filtroMarca}
            onChange={(e) => setFiltroMarca(e.target.value)}
          >
            <option value="">Todas las marcas</option>
            {opcionesFiltros.marcas.map(marca => (
              <option key={marca} value={marca}>
                {marca}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Segunda línea: Categoría y Subcategoría */}
      <div className="row g-3">
        <div className="col-lg-6 col-md-6">
          <label htmlFor={`filtro-categoria-${tipoVista}`} className="form-label">
            <i className="fas fa-tags me-1"></i>
            Categoría
          </label>
          <select
            id={`filtro-categoria-${tipoVista}`}
            className="form-select"
            value={filtroCategoria}
            onChange={(e) => setFiltroCategoria(e.target.value)}
          >
            <option value="">Todas las categorías</option>
            {opcionesFiltros.categorias.map(categoria => (
              <option key={categoria} value={categoria}>
                {categoria}
              </option>
            ))}
          </select>
        </div>

        <div className="col-lg-6 col-md-6">
          <label htmlFor={`filtro-subcategoria-${tipoVista}`} className="form-label">
            <i className="fas fa-list me-1"></i>
            Subcategoría
          </label>
          <select
            id={`filtro-subcategoria-${tipoVista}`}
            className="form-select"
            value={filtroSubcategoria}
            onChange={(e) => setFiltroSubcategoria(e.target.value)}
          >
            <option value="">Todas las subcategorías</option>
            {opcionesFiltros.subcategorias.map(subcategoria => (
              <option key={subcategoria} value={subcategoria}>
                {subcategoria}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FiltrosProductos;
